import React from 'react';

const SendTestUser = ({ value, onChange, onClick }) => {
    return (
        <div>
            <div style={{ margin: '8px 0' }}>Send test for users (separated with ';')</div>
            <div><input className="form-control" value={value || ''} onChange={onChange} /></div>
            <div style={{ padding: '8px 0' }}>
                <button disabled={!value} className="btn btn-success" onClick={onClick}>Send</button>
            </div>
        </div>
    );
};

export default SendTestUser;



// WEBPACK FOOTER //
// ./src/pages/Notifications/SendTestUser.js